module.exports = {
      id: "humoursatire-entertainment-usage",
      viewBox: "0 0 77 77",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#humoursatire-entertainment",
      toString: function () {
        return this.url;
      }
    }